// Dummy data for Care Roadmap prototype
export const DUMMY_RESOURCES = [
  {
    id: '1',
    milestone: 'diagnosis',
    name: 'Autism Diagnostic Center',
    description: 'Comprehensive autism diagnostic services with experienced specialists. We provide thorough assessments for children and adults.',
    address: '123 Main St, New York, NY 10001',
    city: 'New York',
    state: 'NY',
    zipCode: '10001',
    country: 'US',
    coordinates: { lat: 40.7128, lng: -74.0060 },
    phone: '+1 (212) 555-0123',
    email: 'info@autismcenter.com',
    website: 'https://autismcenter.com',
    experienceYears: 15,
    tags: ['autism', 'ADHD', 'assessment'],
    rating: 4.8,
    reviewCount: 127,
    verified: true
  },
  {
    id: '2',
    milestone: 'diagnosis',
    name: 'Neurodevelopmental Assessment Clinic',
    description: 'Specialized in ADHD and learning disability assessments. Family-friendly environment with compassionate staff.',
    address: '456 Park Ave, New York, NY 10022',
    city: 'New York',
    state: 'NY',
    zipCode: '10022',
    country: 'US',
    coordinates: { lat: 40.7614, lng: -73.9776 },
    phone: '+1 (212) 555-0456',
    email: 'contact@neuroassess.com',
    website: 'https://neuroassess.com',
    experienceYears: 10,
    tags: ['ADHD', 'dyslexia', 'assessment'],
    rating: 4.5,
    reviewCount: 89,
    verified: true
  },
  {
    id: '3',
    milestone: 'diagnosis',
    name: 'Child Development Center',
    description: 'Early intervention and diagnostic services for young children. Accepting new patients.',
    address: '789 Broadway, New York, NY 10003',
    city: 'New York',
    state: 'NY',
    zipCode: '10003',
    country: 'US',
    coordinates: { lat: 40.7282, lng: -73.9942 },
    phone: '+1 (212) 555-0789',
    email: 'info@childdevcenter.com',
    website: 'https://childdevcenter.com',
    experienceYears: 20,
    tags: ['autism', 'early intervention', 'assessment'],
    rating: 4.9,
    reviewCount: 203,
    verified: true
  },
  {
    id: '4',
    milestone: 'diagnosis',
    name: 'Behavioral Health Associates',
    description: 'Comprehensive psychological and neuropsychological testing services.',
    address: '321 5th Ave, New York, NY 10016',
    city: 'New York',
    state: 'NY',
    zipCode: '10016',
    country: 'US',
    coordinates: { lat: 40.7450, lng: -73.9820 },
    phone: '+1 (212) 555-0321',
    email: 'info@behavioralhealth.com',
    website: 'https://behavioralhealth.com',
    experienceYears: 12,
    tags: ['ADHD', 'anxiety', 'assessment'],
    rating: 4.3,
    reviewCount: 56,
    verified: false
  },
  {
    id: '5',
    milestone: 'diagnosis',
    name: 'Spectrum Diagnostic Services',
    description: 'Autism spectrum disorder evaluations for all ages. Insurance accepted.',
    address: '654 Lexington Ave, New York, NY 10022',
    city: 'New York',
    state: 'NY',
    zipCode: '10022',
    country: 'US',
    coordinates: { lat: 40.7589, lng: -73.9705 },
    phone: '+1 (212) 555-0654',
    email: 'contact@spectrumdiag.com',
    website: 'https://spectrumdiag.com',
    experienceYears: 8,
    tags: ['autism', 'assessment'],
    rating: 4.6,
    reviewCount: 142,
    verified: true
  },
  {
    id: '6',
    milestone: 'diagnosis',
    name: 'Learning Differences Clinic',
    description: 'Specialized assessments for dyslexia, dyscalculia, and other learning differences.',
    address: '987 Madison Ave, New York, NY 10021',
    city: 'New York',
    state: 'NY',
    zipCode: '10021',
    country: 'US',
    coordinates: { lat: 40.7736, lng: -73.9632 },
    phone: '+1 (212) 555-0987',
    email: 'info@learningdiff.com',
    website: 'https://learningdiff.com',
    experienceYears: 18,
    tags: ['dyslexia', 'dyscalculia', 'assessment'],
    rating: 4.7,
    reviewCount: 98,
    verified: true
  },
  {
    id: '7',
    milestone: 'diagnosis',
    name: 'Pediatric Neurology Center',
    description: 'Expert neurological assessments for children with developmental concerns.',
    address: '234 West End Ave, New York, NY 10023',
    city: 'New York',
    state: 'NY',
    zipCode: '10023',
    country: 'US',
    coordinates: { lat: 40.7765, lng: -73.9843 },
    phone: '+1 (212) 555-0234',
    email: 'info@pedneuro.com',
    website: 'https://pedneuro.com',
    experienceYears: 22,
    tags: ['autism', 'ADHD', 'early intervention'],
    rating: 4.9,
    reviewCount: 176,
    verified: true
  },
  {
    id: '8',
    milestone: 'diagnosis',
    name: 'Cognitive Assessment Group',
    description: 'Comprehensive cognitive and educational testing services.',
    address: '567 Amsterdam Ave, New York, NY 10024',
    city: 'New York',
    state: 'NY',
    zipCode: '10024',
    country: 'US',
    coordinates: { lat: 40.7870, lng: -73.9754 },
    phone: '+1 (212) 555-0567',
    email: 'contact@cogassess.com',
    website: 'https://cogassess.com',
    experienceYears: 14,
    tags: ['ADHD', 'dyslexia', 'assessment'],
    rating: 4.4,
    reviewCount: 67,
    verified: false
  },
  {
    id: '9',
    milestone: 'diagnosis',
    name: 'Family Neurodevelopmental Services',
    description: 'Holistic approach to neurodevelopmental assessments for the whole family.',
    address: '890 Columbus Ave, New York, NY 10025',
    city: 'New York',
    state: 'NY',
    zipCode: '10025',
    country: 'US',
    coordinates: { lat: 40.7956, lng: -73.9665 },
    phone: '+1 (212) 555-0890',
    email: 'info@familyneuro.com',
    website: 'https://familyneuro.com',
    experienceYears: 16,
    tags: ['autism', 'ADHD', 'anxiety', 'assessment'],
    rating: 4.6,
    reviewCount: 134,
    verified: true
  },
  {
    id: '10',
    milestone: 'diagnosis',
    name: 'Metropolitan Autism Center',
    description: 'Leading autism diagnostic center with state-of-the-art facilities.',
    address: '111 Central Park West, New York, NY 10023',
    city: 'New York',
    state: 'NY',
    zipCode: '10023',
    country: 'US',
    coordinates: { lat: 40.7829, lng: -73.9654 },
    phone: '+1 (212) 555-0111',
    email: 'info@metroautism.com',
    website: 'https://metroautism.com',
    experienceYears: 25,
    tags: ['autism', 'early intervention', 'assessment'],
    rating: 4.8,
    reviewCount: 289,
    verified: true
  },
  {
    id: '11',
    milestone: 'diagnosis',
    name: 'Developmental Pediatrics Associates',
    description: 'Specialized developmental and behavioral pediatrics practice.',
    address: '222 East 86th St, New York, NY 10028',
    city: 'New York',
    state: 'NY',
    zipCode: '10028',
    country: 'US',
    coordinates: { lat: 40.7794, lng: -73.9532 },
    phone: '+1 (212) 555-0222',
    email: 'info@devpeds.com',
    website: 'https://devpeds.com',
    experienceYears: 19,
    tags: ['autism', 'ADHD', 'early intervention'],
    rating: 4.7,
    reviewCount: 156,
    verified: true
  },
  {
    id: '12',
    milestone: 'diagnosis',
    name: 'Neurodiversity Evaluation Center',
    description: 'Affirming assessments celebrating neurodiversity. LGBTQ+ friendly.',
    address: '333 Greenwich St, New York, NY 10013',
    city: 'New York',
    state: 'NY',
    zipCode: '10013',
    country: 'US',
    coordinates: { lat: 40.7223, lng: -74.0101 },
    phone: '+1 (212) 555-0333',
    email: 'hello@neurodiversityeval.com',
    website: 'https://neurodiversityeval.com',
    experienceYears: 7,
    tags: ['autism', 'ADHD', 'assessment'],
    rating: 4.9,
    reviewCount: 112,
    verified: true
  },
  {
    id: '13',
    milestone: 'diagnosis',
    name: 'Brooklyn Diagnostic Services',
    description: 'Comprehensive diagnostic services in Brooklyn. Evening appointments available.',
    address: '444 Atlantic Ave, Brooklyn, NY 11217',
    city: 'Brooklyn',
    state: 'NY',
    zipCode: '11217',
    country: 'US',
    coordinates: { lat: 40.6838, lng: -73.9801 },
    phone: '+1 (718) 555-0444',
    email: 'info@brooklyndiag.com',
    website: 'https://brooklyndiag.com',
    experienceYears: 11,
    tags: ['autism', 'ADHD', 'dyslexia', 'assessment'],
    rating: 4.5,
    reviewCount: 93,
    verified: false
  },
  {
    id: '14',
    milestone: 'diagnosis',
    name: 'Queens Neurodevelopmental Clinic',
    description: 'Multilingual staff providing culturally sensitive assessments.',
    address: '555 Queens Blvd, Queens, NY 11373',
    city: 'Queens',
    state: 'NY',
    zipCode: '11373',
    country: 'US',
    coordinates: { lat: 40.7396, lng: -73.8789 },
    phone: '+1 (718) 555-0555',
    email: 'contact@queensneuro.com',
    website: 'https://queensneuro.com',
    experienceYears: 13,
    tags: ['autism', 'ADHD', 'assessment', 'early intervention'],
    rating: 4.6,
    reviewCount: 145,
    verified: true
  },
  {
    id: '15',
    milestone: 'diagnosis',
    name: 'Bronx Child Psychology Center',
    description: 'Affordable diagnostic services with sliding scale fees available.',
    address: '666 Grand Concourse, Bronx, NY 10451',
    city: 'Bronx',
    state: 'NY',
    zipCode: '10451',
    country: 'US',
    coordinates: { lat: 40.8209, lng: -73.9254 },
    phone: '+1 (718) 555-0666',
    email: 'info@bronxchildpsych.com',
    website: 'https://bronxchildpsych.com',
    experienceYears: 9,
    tags: ['autism', 'ADHD', 'anxiety', 'assessment'],
    rating: 4.3,
    reviewCount: 78,
    verified: true
  }
];

export const AVAILABLE_COUNTRIES = [
  { 
    code: 'US', 
    name: 'United States', 
    flag: '🇺🇸',
    center: [39.8283, -98.5795], // Geographic center of US
    zoom: 4
  },
  { 
    code: 'IN', 
    name: 'India', 
    flag: '🇮🇳',
    center: [20.5937, 78.9629], // Geographic center of India
    zoom: 5
  },
  { 
    code: 'GB', 
    name: 'United Kingdom', 
    flag: '🇬🇧',
    center: [54.7024, -3.2766], // Geographic center of UK
    zoom: 6
  }
];

export const AVAILABLE_TAGS = [
  'autism',
  'ADHD',
  'dyslexia',
  'dyscalculia',
  'anxiety',
  'assessment',
  'early intervention'
];

export const AVAILABLE_CONDITIONS = [
  'Autism Spectrum Disorder',
  'ADHD',
  'Dyslexia',
  'Dyscalculia',
  'Anxiety',
  'Sensory Processing Disorder',
  'Down Syndrome',
  'Cerebral Palsy',
  'Intellectual Disability',
  'Speech & Language Delay'
];
